export type ColorType = 'green' | 'red' | 'blue' | 'yellow' | 'orange';

const colorSchema = {
  green: {
    gradient:
      'linear-gradient(to right, var(--colors-campaign-green-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-green-4), var(--colors-campaign-green-2))`,
    cardText: 'text-campaign/green-4',
    badgeBg: 'bg-colors/campaign-green-3',
    badgeText: 'text-text/on-dark',
    bulletColor: 'text-campaign/green-3',
    tileBorder: 'border-colors/campaign-green-3',
    button: {
      border: 'border-colors/campaign-green-4',
      text: 'text-colors/campaign-green-4',
    },
  },
  red: {
    gradient: 'linear-gradient(to right, var(--colors-campaign-red-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-red-4), var(--colors-campaign-red-2))`,
    cardText: 'text-campaign/red-3',
    badgeBg: 'bg-colors/campaign-red-3',
    badgeText: 'text-text/on-dark',
    bulletColor: 'text-campaign/red-3',
    tileBorder: 'border-colors/campaign-red-3',
    button: {
      border: 'border-colors/campaign-red-3',
      text: 'text-colors/campaign-red-3',
    },
  },
  blue: {
    gradient: 'linear-gradient(to right, var(--colors-campaign-blue-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-blue-4), var(--colors-campaign-blue-2))`,
    cardText: 'text-campaign/blue-4',
    badgeBg: 'bg-colors/campaign-blue-3',
    badgeText: 'text-text/on-dark',
    bulletColor: 'text-campaign/blue-3',
    tileBorder: 'border-colors/campaign-blue-3',
    button: {
      border: 'border-colors/campaign-blue-4',
      text: 'text-colors/campaign-blue-4',
    },
  },
  yellow: {
    gradient:
      'linear-gradient(to right, var(--colors-campaign-yellow-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-yellow-4), var(--colors-campaign-yellow-2))`,
    cardText: 'text-campaign/yellow-4',
    badgeBg: 'bg-colors/campaign-yellow-3',
    badgeText: 'text-text/on-dark',
    bulletColor: 'text-campaign/yellow-3',
    tileBorder: 'border-colors/campaign-yellow-3',
    button: {
      border: 'border-colors/campaign-yellow-4',
      text: 'text-colors/campaign-yellow-4',
    },
  },
  orange: {
    gradient:
      'linear-gradient(to right, var(--colors-campaign-orange-1), white)',
    topGradient: `linear-gradient(to right, var(--colors-campaign-orange-4), var(--colors-campaign-orange-2))`,
    cardText: 'text-campaign/orange-4',
    badgeBg: 'bg-colors/campaign-orange-3',
    badgeText: 'text-text/on-dark',
    bulletColor: 'text-campaign/orange-3',
    tileBorder: 'border-colors/campaign-orange-3',
    button: {
      border: 'border-colors/campaign-orange-4',
      text: 'text-colors/campaign-orange-4',
    },
  },
};

export type ColorSchema = (typeof colorSchema)[ColorType];

export const getColorSchema = (color: ColorType): ColorSchema => {
  return colorSchema[color];
};
